export default "__VITE_ASSET__C_fCE1gx__"